import { split } from "../../../../fable_modules/fable-library.3.7.9/String.js";
import { StringUtils_replace } from "../../../../Shared/Shared.js";
import { empty, singleton, append, delay, toList } from "../../../../fable_modules/fable-library.3.7.9/Seq.js";
import { FSharpSet__Contains } from "../../../../fable_modules/fable-library.3.7.9/Set.js";
import { FSharpMap__get_Item } from "../../../../fable_modules/fable-library.3.7.9/Map.js";
import { createElement } from "react";
import { ofArray, singleton as singleton_1 } from "../../../../fable_modules/fable-library.3.7.9/List.js";
import { Interop_reactApi } from "../../../../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { createObj } from "../../../../fable_modules/fable-library.3.7.9/Util.js";
import { Helpers_combineClasses } from "../../../../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { Corpus } from "../../../../fs/Model/Model.js";
import { partsOfSpeech } from "./Cwb.js";
import { quickView, selectionTable, menu } from "./Metadata.js";

export function dataFileButtons(textId, corpusInfo) {
    const parts = split(textId, ["_"], null, 0);
    const assignmentFile = `${parts[1]}_${parts[2]}.pdf`;
    const studentPaperFile = `${textId}.pdf`;
    const commentedFileStem = StringUtils_replace("_ORIG", "_COMM", textId);
    const commentedFile = `${commentedFileStem}.pdf`;
    return toList(delay(() => {
        let props_2, elems_1, elms;
        return append(FSharpSet__Contains(FSharpMap__get_Item(corpusInfo.DataFiles, "oppgavetekster"), assignmentFile) ? singleton((props_2 = ofArray([["className", "is-warning"], ["className", "is-small"], ["style", {
            marginRight: 5,
        }], ["data-tooltip", "Assignment text"], ["className", "has-tooltip-right"], ["href", `https://tekstlab.uio.no/trawl_files/oppgavetekster/no/${assignmentFile}`], ["target", "_blank"], (elems_1 = [(elms = singleton_1(createElement("i", {
            className: "fa-regular fa-file",
        })), createElement("span", {
            className: "icon",
            children: Interop_reactApi.Children.toArray(Array.from(elms)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]), createElement("a", createObj(Helpers_combineClasses("button", props_2))))) : empty(), delay(() => {
            let props_6, elems_3, elms_1;
            return append(FSharpSet__Contains(FSharpMap__get_Item(corpusInfo.DataFiles, "oppgavesvar"), studentPaperFile) ? singleton((props_6 = ofArray([["className", "is-info"], ["className", "is-small"], ["style", {
                marginRight: 5,
            }], ["data-tooltip", "Student paper"], ["className", "has-tooltip-right"], ["href", `https://tekstlab.uio.no/trawl_files/oppgavesvar/no/${studentPaperFile}`], ["target", "_blank"], (elems_3 = [(elms_1 = singleton_1(createElement("i", {
                className: "fa-regular fa-file",
            })), createElement("span", {
                className: "icon",
                children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]), createElement("a", createObj(Helpers_combineClasses("button", props_6))))) : empty(), delay(() => {
                let props_10, elems_5, elms_2;
                return FSharpSet__Contains(FSharpMap__get_Item(corpusInfo.DataFiles, "oppgavesvar_m_komm"), commentedFile) ? singleton((props_10 = ofArray([["className", "is-success"], ["className", "is-small"], ["style", {
                    marginRight: 5,
                }], ["data-tooltip", "Student paper with teacher comments"], ["className", "has-tooltip-right"], ["href", `https://tekstlab.uio.no/trawl_files/oppgavesvar_m_komm/no/${commentedFile}`], ["target", "_blank"], (elems_5 = [(elms_2 = singleton_1(createElement("i", {
                    className: "fa-regular fa-file",
                })), createElement("span", {
                    className: "icon",
                    children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
                }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]), createElement("a", createObj(Helpers_combineClasses("button", props_10))))) : empty();
            }));
        }));
    }));
}

export function getCorpus(config) {
    return new (class extends Corpus {
        constructor() {
            super(config, singleton_1(partsOfSpeech), menu, selectionTable, quickView);
        }
        ["Model.Corpus.ResultLinksZ731E88D3"](_arg1, _arg2, textId, _arg3, corpusInfo) {
            let elems;
            const props = ofArray([["style", {
                justifyContent: "center",
            }], (elems = dataFileButtons(textId, corpusInfo), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]);
            return createElement("div", createObj(Helpers_combineClasses("buttons", props)));
        }
        ["Model.Corpus.SelectionTableFirstColumnZ3081B86A"](textId_1, corpusInfo_1) {
            let elems_1;
            return createElement("td", {
                style: {
                    whiteSpace: "nowrap",
                },
                children: createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexWrap: "nowrap",
                }], (elems_1 = dataFileButtons(textId_1, corpusInfo_1), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))),
            });
        }
    }
    )();
}

